require('./src/scss/main.scss');

// custom typefaces
// import "typeface-montserrat"
// import "typeface-merriweather"
